// frontend/src/pages/public/Terms/TermsPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../components/SEO/SEO";
import PublicHeader from "../../../components/PublicHeader/PublicHeader";
import PublicFooter from "../../../components/PublicFooter/PublicFooter";
import { termsPage } from "./TermsContent";
import "../Legal/LegalPage.css";

export default function TermsPage() {
  const { eyebrow, title, subtitle, sections, ctas } = termsPage;

  return (
    <div className="ocf-legal">
      <SEO
        title="Terms of Use"
        description="Read the terms and conditions for using AcceptingMD. Understand your rights and responsibilities when using our platform."
      />
      <PublicHeader variant="solid" />

      {/* Hero */}
      <header className="ocf-legal-hero">
        <div className="ocf-legal-hero-inner">
          <div className="ocf-legal-hero-badge">{eyebrow}</div>
          <h1>{title}</h1>
          <p className="ocf-legal-hero-text">{subtitle}</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="ocf-legal-main">
        <div className="ocf-legal-card">
          {/* Sections */}
          <div className="ocf-legal-sections">
            {sections.map((section, idx) => (
              <section key={idx} className="ocf-legal-section">
                <h2 className="ocf-legal-section-title">{section.title}</h2>
                <div className="ocf-legal-section-body">
                  {section.body.map((paragraph, pIdx) => (
                    <p key={pIdx}>{paragraph}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          {/* Last Updated */}
          <div className="ocf-legal-updated">
            Last updated: January 2025
          </div>
        </div>
      </main>

      {/* CTA Section */}
      {ctas && (
        <section className="ocf-legal-cta">
          <div className="ocf-legal-cta-inner">
            <h2>{ctas.title}</h2>
            <p>{ctas.subtitle}</p>
            <div className="ocf-legal-cta-buttons">
              {ctas.primary && (
                <Link to={ctas.primary.to} className="ocf-legal-cta-btn ocf-legal-cta-btn--primary">
                  {ctas.primary.label}
                </Link>
              )}
              {ctas.secondary && (
                <Link to={ctas.secondary.to} className="ocf-legal-cta-btn ocf-legal-cta-btn--ghost">
                  {ctas.secondary.label}
                </Link>
              )}
            </div>
          </div>
        </section>
      )}

      <PublicFooter />
    </div>
  );
}
